import { ReactComponent as Activity } from '../assets/images/svgs/icons/Activity.svg';
import { ReactComponent as AlertTriangle } from '../assets/images/svgs/icons/AlertTriangle.svg';
import { ReactComponent as Award } from '../assets/images/svgs/icons/Award.svg';
import { ReactComponent as Ban } from '../assets/images/svgs/icons/Ban.svg';
import { ReactComponent as BandAid } from '../assets/images/svgs/icons/BandAid.svg';
import { ReactComponent as Bell } from '../assets/images/svgs/icons/Bell.svg';
import { ReactComponent as Calendar } from '../assets/images/svgs/icons/calendar.svg';
import { ReactComponent as CheckSimple } from '../assets/images/svgs/icons/checksimple.svg';
import { ReactComponent as CheckSimpleSmall } from '../assets/images/svgs/icons/CheckSimpleSmall.svg';
import { ReactComponent as Clock } from '../assets/images/svgs/icons/clock.svg';
import { ReactComponent as Config } from '../assets/images/svgs/icons/config.svg';
import { ReactComponent as Cross } from '../assets/images/svgs/icons/cross.svg';
import { ReactComponent as Crown } from '../assets/images/svgs/icons/Crown.svg';
import { ReactComponent as Edit } from '../assets/images/svgs/icons/edit.svg';
import { ReactComponent as EditPen } from '../assets/images/svgs/icons/EditPen.svg';
import { ReactComponent as EditPencil } from '../assets/images/svgs/icons/EditPencil.svg';
import { ReactComponent as EyeOpen } from '../assets/images/svgs/icons/EyeOpen.svg';
import { ReactComponent as EyeVisible } from '../assets/images/svgs/icons/eyevisible.svg';
import { ReactComponent as EyeVisibleOff } from '../assets/images/svgs/icons/eyevisibleoff.svg';
import { ReactComponent as Export } from '../assets/images/svgs/icons/export.svg';
import { ReactComponent as Flag } from '../assets/images/svgs/icons/Flag.svg';
import { ReactComponent as Glasses } from '../assets/images/svgs/icons/Glasses.svg';
import { ReactComponent as Heart } from '../assets/images/svgs/icons/Heart.svg';
import { ReactComponent as Heartbeat } from '../assets/images/svgs/icons/Heartbeat.svg';
import { ReactComponent as HeartRate } from '../assets/images/svgs/icons/HeartRate.svg';
import { ReactComponent as Import } from '../assets/images/svgs/icons/import.svg';
import { ReactComponent as Info } from '../assets/images/svgs/icons/info.svg';
import { ReactComponent as Locker } from '../assets/images/svgs/icons/locker.svg';
import { ReactComponent as NoEntry } from '../assets/images/svgs/icons/NoEntry.svg';
import { ReactComponent as NoPicture } from '../assets/images/svgs/icons/nopicture.svg';
import { ReactComponent as Picture } from '../assets/images/svgs/icons/picture.svg';
import { ReactComponent as PinSmall } from '../assets/images/svgs/icons/PinSmall.svg';
import { ReactComponent as PuzzlePiece } from '../assets/images/svgs/icons/PuzzlePiece.svg';
import { ReactComponent as Reception } from '../assets/images/svgs/icons/reception.svg';
import { ReactComponent as Search } from '../assets/images/svgs/icons/search.svg';
import { ReactComponent as SearchSmall } from '../assets/images/svgs/icons/SearchSmall.svg';
import { ReactComponent as SendSmall } from '../assets/images/svgs/icons/SendSmall.svg';
import { ReactComponent as Settings } from '../assets/images/svgs/icons/Settings.svg';
import { ReactComponent as SmileyHappy } from '../assets/images/svgs/icons/SmileyHappy.svg';
import { ReactComponent as SmileySad } from '../assets/images/svgs/icons/SmileySad.svg';
import { ReactComponent as StarSmall } from '../assets/images/svgs/icons/StarSmall.svg';
import { ReactComponent as Stethoscope } from '../assets/images/svgs/icons/Stethoscope.svg';
import { ReactComponent as TagSmall } from '../assets/images/svgs/icons/TagSmall.svg';
import { ReactComponent as Target } from '../assets/images/svgs/icons/Target.svg';
import { ReactComponent as ThumbUp } from '../assets/images/svgs/icons/ThumbUp.svg';
import { ReactComponent as Trophy } from '../assets/images/svgs/icons/Trophy.svg';
import { ReactComponent as Wrench } from '../assets/images/svgs/icons/Wrench.svg';

export const CONFIG_WORK_CHECKLIST_ICONS_LIST = [
	{ id: '1', icon: CheckSimple },
	{ id: '2', icon: EyeVisible },
	{ id: '3', icon: Cross },
	{ id: '4', icon: EyeVisibleOff },
	{ id: '5', icon: Clock },
	{ id: '6', icon: Reception },
	{ id: '7', icon: Search },
	{ id: '8', icon: Info },
	{ id: '9', icon: Calendar },
	{ id: '10', icon: Picture },
	{ id: '11', icon: NoPicture },
	{ id: '12', icon: Export },
	{ id: '13', icon: Import },
	{ id: '14', icon: Config },
	{ id: '15', icon: Locker },
	{ id: '16', icon: Edit },
	{ id: '17', icon: CheckSimpleSmall },
	{ id: '18', icon: EyeOpen },
	{ id: '19', icon: NoEntry },
	{ id: '20', icon: AlertTriangle },
	{ id: '21', icon: SearchSmall },
	{ id: '22', icon: SmileyHappy },
	{ id: '23', icon: SmileySad },
	{ id: '24', icon: ThumbUp },
	{ id: '25', icon: Bell },
	{ id: '26', icon: Target },
	{ id: '27', icon: TagSmall },
	{ id: '28', icon: Flag },
	{ id: '29', icon: EditPen },
	{ id: '30', icon: EditPencil },
	{ id: '31', icon: Settings },
	{ id: '32', icon: PinSmall },
	{ id: '33', icon: StarSmall },
	{ id: '34', icon: SendSmall },
	{ id: '35', icon: Activity },
	{ id: '36', icon: Award },
	{ id: '37', icon: Wrench },
	{ id: '38', icon: Glasses },
	{ id: '39', icon: Heartbeat },
	{ id: '40', icon: HeartRate },
	{ id: '41', icon: PuzzlePiece },
	{ id: '42', icon: Heart },
	{ id: '43', icon: Ban },
	{ id: '44', icon: BandAid },
	{ id: '45', icon: Stethoscope },
	{ id: '46', icon: Trophy },
	{ id: '47', icon: Crown },
];